module.exports = __webpack_public_path__ + "img/trip_top.08b4e8b8.png";